<template>
  <div>
    <div v-if="$store.state.moderator" class="moderator-view">
      Внимание! Вы находитесь в панели управления пользователя
      {{ $store.state.user.abo_number }}
      <ui-button @click="moderatorUserLogout" size="small" color="primary"
        >Выйти</ui-button
      >
    </div>
    <div class="nav">
      <div class="nav-wrapper">
        <div
          v-show="tablet_breakpoint"
          @click="openMenu"
          :class="gamburgerCssClass"
        >
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
        <img
          @click="
            () => {
              $router.push('/');
              GAEvent('step_1-logo_click');
            }
          "
          class="logo"
          src="@/assets/img/logo.png"
          alt=""
        />
        <div
          v-show="(tablet_breakpoint && mobile_menu_opened) || desktop"
          class="buttons"
        >
          <!--<div @click="() => {showVideo(); this.GAEvent('step_1-main_menu_click', 'click_text', 'Видео')}" class="helper">
            <svg-icon type="new-teach" />
            Видео
          </div>-->
          <a
            :href="instructionLink"
            @click="
              GAEvent('step_1-main_menu_click', 'click_text', 'Инструкция')
            "
            target="_blank"
            class="helper"
          >
            <svg-icon type="new-instruction" />
            Инструкция
          </a>
          <div
            @click="
              () => {
                $router.push('/support');
                GAEvent('step_1-main_menu_click', 'click_text', 'Поддержка');
              }
            "
            class="helper"
          >
            <svg-icon type="new-help" />
            Поддержка
          </div>
          <div
            class="helper"
            @click="
              () => {
                logoutAction();
                GAEvent('step_1-main_menu_click', 'click_text', 'Выход');
              }
            "
            v-if="$store.state.user"
          >
            Выйти
          </div>
        </div>
      </div>
      <ui-modal ref="videoModal" @close="$refs.video.pause()">
        <h2 class="header" slot="header">Обучающее видео</h2>
        <video
          ref="video"
          src="https://amwaypersonalpage.ru/media/PRW-intro-video.0062cab6.mp4"
          controls
          preload="auto"
        ></video>
      </ui-modal>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    const tablet_breakpoint = window.innerWidth <= 768;
    const mobile_menu_opened = false;
    const desktop = !tablet_breakpoint;
    let instructionLink = "https://amwaypersonalpage.ru/PRW-instruction.pdf";
    if (this.$store.state.isKZ) {
      if (this.$store.state.userTypes && this.$store.state.userTypes.vip) {
        instructionLink =
          "https://kz.amwaypersonalpage.ru/PRW-instruction-KZ-VIP.pdf";
      } else {
        instructionLink =
          "https://kz.amwaypersonalpage.ru/PRW-instruction-KZ.pdf";
      }
    } else {
      if (this.$store.state.userTypes && this.$store.state.userTypes.vip) {
        instructionLink =
          "https://amwaypersonalpage.ru/PRW-instruction-VIP.pdf";
      }
    }
    return {
      tablet_breakpoint,
      mobile_menu_opened,
      desktop,
      instructionLink
    };
  },
  methods: {
    ...mapActions(["logoutAction"]),
    showHelp() {
      this.$eventBus.$emit("showHelp");
    },
    openMenu() {
      this.mobile_menu_opened = !this.mobile_menu_opened;
      this.$eventBus.$emit("mobile_menu_opened", this.mobile_menu_opened);
    },
    showVideo() {
      this.$refs.videoModal.open();
      this.$refs.video.play();
    },
    moderatorUserLogout() {
      return fetch(
        `${process.env.VUE_APP_API_ROOT}/api/moderation/logout_as_user`,
        {
          method: "POST",
          credentials: "include",
          headers: {}
        }
      )
        .then(r => r.json())
        .then(r => {
          if (r.status === "success") {
            window.location.reload();
          }
        });
    }
  },
  computed: {
    ...mapState(["user"]),
    ...mapGetters(["getComponentByName"]),
    avatar() {
      if (this.user && this.user.avatar) {
        return this.user.avatar;
      }
      return require("@/assets/img/avatar.svg");
    },
    gamburgerCssClass() {
      return {
        opened: this.mobile_menu_opened,
        gamburger: true
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";

$mobile: "screen and (max-width: 480px)";
.gamburger {
  margin-left: 30px;

  & > * {
    width: 25px;
    height: 3px;
    background: #ffffff;
  }

  & > *:first-child ~ * {
    margin-top: 6px;
  }

  & > *:first-child {
    display: block;
  }

  @media #{$tablet} {
    /*display: block;*/
  }

  &.opened {
    & > *:first-child {
      display: none;

      & + div {
        transform: rotate(45deg);
        margin-top: -3px;

        & + div {
          margin-top: -3px;
          transform: rotate(-45deg);
        }
      }
    }
  }
}

video {
  @media #{$tablet} {
    width: 100%;
  }
}

.buttons {
  user-select: none;
  height: 100%;
  .accountid {
    display: flex;
    align-items: center;

    span {
      margin-left: 10px;
      /deep/ svg {
        vertical-align: middle;
      }
    }
  }

  @media #{$tablet} {
    position: absolute;
    height: initial;
    top: calc(100% - 1px);
    right: 0;
    background: $new-blue;
    flex-flow: column nowrap;
    align-items: flex-start;
    width: 225px;
    z-index: 2;
    padding: 30px 30px 40px;
    & > * {
      border-right: none !important;
    }
  }

  @media #{$mobile} {
    width: 100%;
  }

  img {
    width: 42px;
    height: 42px;
    margin-right: 10px;
    border-radius: 50%;
    object-fit: cover;
  }

  button {
    cursor: pointer;
    color: red;
    background: none;
    border: none;
    padding: 0;
  }

  display: flex;
  align-items: center;
}

.logo {
  width: 123px;
  height: 42px;
  cursor: pointer;
}

.nav {
  height: 75px;
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: $new-blue;
  z-index: 2;
  padding: 15px 0;
  a {
    color: white;
    margin-right: 10px;
  }

  &-wrapper {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 100%;
    @media #{$tablet} {
      flex-direction: row-reverse;
      justify-content: space-between;
      padding: 0 30px;
    }
    @media #{$mobile} {
      padding: 0 15px;
    }
  }
}

.helper {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  color: #ffffff;
  padding: 0 25px;
  height: 100%;
  cursor: pointer;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.2s ease-in-out;
  &:not(:last-child) {
    border-right: 1px solid #ffffff;
  }
  &:last-child {
    padding-right: 0;
  }
  /deep/ svg * {
    transition: all 0.2s ease-in-out;
  }
  &:hover {
    color: #e0e0e0;
    /deep/ svg * {
      stroke: #e0e0e0;
    }
  }
  span {
    font-family: $fontfamily;
    font-size: 16px;
    color: white;
    margin-right: 10px;
    cursor: pointer;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    @media #{$tablet} {
      margin-right: 0;
    }
    @media #{$mobile} {
      display: none;
    }
  }

  @media #{$tablet} {
    flex-direction: row-reverse;
    justify-content: space-between;
    padding: 20px 0;
    width: 100%;
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      justify-content: flex-end;
      padding-bottom: 0;
    }
  }
  @media #{$mobile} {
    justify-content: center !important;
  }
}

.moderator-view {
  background: #ff5c5c;
  width: 100%;
  padding: 5px;
  color: #ffffff;
  text-align: center;
}
</style>
